import { Navigate, useLocation } from "react-router-dom";
import { AuthData, useAuth } from "../contexts/Auth";
import { usePremium } from "../contexts/Premium";

const RequireAuth = ({
  premiumOnly,
  children,
}: {
  premiumOnly?: boolean;
  children: React.ReactNode;
}) => {
  const { authData } = useAuth() as { authData: AuthData };
  const { isPremium } = usePremium() as { isPremium: boolean };
  let location = useLocation();

  if (premiumOnly && !isPremium) {
    return <Navigate to="/go-premium" state={{ from: location }} replace />;
  }

  if (!authData) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
